import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingChangesApi from '@/features/dashboard/bookingChanges/api/bookingChangesApi.ts';
import { bookingChangesApiQueryKeys } from '@/features/dashboard/bookingChanges/api/bookingChangesApi.queryKeys.ts';
import { ChangeItemDto } from '@/features/dashboard/bookingChanges/types/dto/ChangeItemDto.ts';
import { bookingChangeDetailMapper } from '@/features/dashboard/bookingChanges/types/BookingChangeDetailDto.mapper.ts';

interface PatchDraftParams {
  changeId: string;
  /**
   * Komplet pozycji szkicu **po** zmianie — PATCH podmienia całą zawartość
   * paczki, więc wysłanie samej edytowanej pozycji skasowałoby resztę.
   */
  items: ChangeItemDto[];
}

/** Zapis edycji pola do otwartego szkicu. */
const usePatchDraft = (bookingId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ changeId, items }: PatchDraftParams) =>
      bookingChangesApi.patchDraft(
        bookingId,
        changeId,
        bookingChangeDetailMapper.toPatchRequest(items),
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bookingChangesApiQueryKeys.booking(bookingId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się zapisać zmiany w szkicu', {
        description: error.message,
      });
    },
  });
};

export default usePatchDraft;
